// extracted by mini-css-extract-plugin
export default {"loader":"_2e7W4"};